/*
 * THIS FILE WAS GENERATED BY "@atproto/lex". DO NOT EDIT.
 */

import { l } from '@atproto/lex'
import * as ModerationDefs from './defs.defs.js'
import * as AdminDefs from '../admin/defs.defs.js'
import * as RepoStrongRef from '../repo/strongRef.defs.js'

const $nsid = 'com.atproto.moderation.createReport'

type $nsid = typeof $nsid

export { $nsid }

export const $params = /*#__PURE__*/ l.params()

export type $Params = l.InferOutput<typeof $params>

export const $input = /*#__PURE__*/ l.jsonPayload({
  reasonType: /*#__PURE__*/ l.ref<ModerationDefs.ReasonType>(
    (() => ModerationDefs.reasonType) as any,
  ),
  reason: /*#__PURE__*/ l.optional(
    /*#__PURE__*/ l.string({ maxGraphemes: 2000, maxLength: 20000 }),
  ),
  subject: /*#__PURE__*/ l.typedUnion(
    [
      /*#__PURE__*/ l.typedRef<AdminDefs.RepoRef>(
        (() => AdminDefs.repoRef) as any,
      ),
      /*#__PURE__*/ l.typedRef<RepoStrongRef.Main>(
        (() => RepoStrongRef.main) as any,
      ),
    ],
    false,
  ),
  modTool: /*#__PURE__*/ l.optional(
    /*#__PURE__*/ l.ref<ModTool>((() => modTool) as any),
  ),
})

export type $Input<B = l.BinaryData> = l.InferPayload<typeof $input, B>
export type $InputBody<B = l.BinaryData> = l.InferPayloadBody<typeof $input, B>

export const $output = /*#__PURE__*/ l.jsonPayload({
  id: /*#__PURE__*/ l.integer(),
  reasonType: /*#__PURE__*/ l.ref<ModerationDefs.ReasonType>(
    (() => ModerationDefs.reasonType) as any,
  ),
  reason: /*#__PURE__*/ l.optional(
    /*#__PURE__*/ l.string({ maxGraphemes: 2000, maxLength: 20000 }),
  ),
  subject: /*#__PURE__*/ l.typedUnion(
    [
      /*#__PURE__*/ l.typedRef<AdminDefs.RepoRef>(
        (() => AdminDefs.repoRef) as any,
      ),
      /*#__PURE__*/ l.typedRef<RepoStrongRef.Main>(
        (() => RepoStrongRef.main) as any,
      ),
    ],
    false,
  ),
  reportedBy: /*#__PURE__*/ l.string({ format: 'did' }),
  createdAt: /*#__PURE__*/ l.string({ format: 'datetime' }),
})

export type $Output<B = l.BinaryData> = l.InferPayload<typeof $output, B>
export type $OutputBody<B = l.BinaryData> = l.InferPayloadBody<
  typeof $output,
  B
>

/** Submit a moderation report regarding an atproto account or record. Implemented by moderation services (with PDS proxying), and requires auth. */
const main = /*#__PURE__*/ l.procedure($nsid, $params, $input, $output)

export { main }

const $lxm = $nsid

type $lxm = typeof $lxm

export { $lxm }

/** Moderation tool information for tracing the source of the action */
type ModTool = {
  $type?: 'com.atproto.moderation.createReport#modTool'

  /**
   * Name/identifier of the source (e.g., 'bsky-app/android', 'bsky-web/chrome')
   */
  name: string

  /**
   * Additional arbitrary metadata about the source
   */
  meta?: l.LexMap
}

export type { ModTool }

/** Moderation tool information for tracing the source of the action */
const modTool = /*#__PURE__*/ l.typedObject<ModTool>(
  $nsid,
  'modTool',
  /*#__PURE__*/ l.object({
    name: /*#__PURE__*/ l.string(),
    meta: /*#__PURE__*/ l.optional(/*#__PURE__*/ l.lexMap()),
  }),
)

export { modTool }
